export default {
	"toMarketing.ParameterError": "參數錯誤!",
	"toMarketing.CallIsComing": "叫叫正在趕來..."
}